import moment from "moment";
import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { socket } from "../../service/socket";
import Header from "./header";
import Sidebar from "./sidebar";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  LOGOUT,
  RESET_REDUX_STATE,
  CLEAR_SEARCH,
  LOGIN,
  RESET_COLOR_PALETTES
} from "../../redux/constants";
import { ApiCall } from "../../utils";
import { customerDetail } from "../../redux/actions/onboarding";

const AuthLayout = ({ children, Component, user }) => {
  const dispatch = useDispatch();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notificationList, setNotificationList] = useState([]);
  const [requestCount, setRequestCount] = useState(0);
  // const ctx = useContext(UserContext);
  const location = useLocation();
  const userData = useSelector((state) => state.auth);
  const { color_palettes } = useSelector((state) => state.palettes);
  const navigate = useNavigate();
  
  // Creating state to get position of chatIcon
  const [{ top, left }, setPosition] = React.useState({
    top: "85%",
    left: "80%",
  });
  const [{ clientX, clientY }, setClient] = React.useState({
    clientX: 0,
    clientY: 0,
  });

  // Message count
  // useEffect(() => {
  //   if(!["customer", "collaborator"].includes(userData?.type)){
  //     (async () => {
  //       const result = await ApiCall.get(
  //         `/chatGroup/main_group_ids`, userData?.token
  //       );
  //       socket.emit("group_join", { data: result.data });
  //     })();
  //   }
  // }, []);

  useEffect(() => {
    if(userData.email){
      socket.emit("join", { sender: userData.email });
    }
  }, [userData, location]);

  useEffect(() => {
    socket.emit("request_pending_count", {
      email: user?.email,
      company_id: user?.company?.id,
    });
  }, []);

  useEffect(() => {
    socket.on("get_pending_count", async (data) => {
      setRequestCount(data);
    });
  }, []);

  // Check for expiration for token in this
  useEffect(() => {
    const expire = moment(user.expire);
    const current_date = moment(moment());
    if (current_date.diff(expire, "day") <= 1) {
      if (moment(current_date).isSameOrAfter(expire, "hour")) {
        if (moment(current_date).isSameOrAfter(expire, "minute")) {
          dispatch({ type: LOGOUT });
          dispatch({ type: RESET_REDUX_STATE });
          dispatch({ type: RESET_COLOR_PALETTES });
          // ctx.logout();
        }
      }
    } else {
      dispatch({ type: LOGOUT });
      dispatch({ type: RESET_REDUX_STATE });
      dispatch({ type: RESET_COLOR_PALETTES });
      // ctx.logout();
    }
  }, [location]);

  // New Message Notification Listener for One-to-One Chatting
  useEffect(() => {
    socket.on("new_user_message_notification", async (data) => {
      if (data.id !== user.id) {
        setNotificationList((prev) => {
          const check = prev.filter((item) => item.id !== data.id);
          const present = prev.find((item) => item.id === data.id);
          return [
            { ...data, count: present ? present?.count + 1 : 1 },
            ...check,
          ];
        });
      }
    });
  }, []);

  useEffect(() => {
    socket.on("get_all_unread_notification", async (data) => {
      setNotificationList(data);
    });
  }, []);

  // New Message Notification Listener for Group Chatting
  useEffect(() => {
    socket.on("new_group_message_notification", async (data) => {
      const emails = JSON.parse(data.user_email);
      if (emails.includes(user.email) && data.sender_email !== user.email) {
        setNotificationList((prev) => {
          const check = prev.filter((item) => item.id !== data.id);
          const present = prev.find((item) => item.id === data.id);
          return [
            { ...data, count: present ? present?.count + 1 : 1 },
            ...check,
          ];
        });
      }
    });
  }, []);

  useEffect(() => {
    if(!["customer", "collaborator"].includes(userData?.type)){
      (async () => {
        const result = await ApiCall.get(
          `/chat/notificationList`, userData?.token
        );
        setNotificationList(result.data);
      })();
    }
  }, []);

  // useEffect(() => {
  //   (async () => {
  //     try {
  //       await ApiCall.get(`/auth/verify`, user?.token);
  //     } catch (error) {
  //       if (error.statusCode === 401) {
  //         dispatch({ type: LOGOUT });
  //         // ctx.logout();
  //       }
  //     }
  //   })();
  // }, [location]);

  // useEffect(() => {
  //   console.log("use effect has been called", !Component.auth.role.includes(userData.type));
  //   if (!userData?.id) return <Navigate to="/login" replace />;
  //   else if (
  //     userData.type === "super-admin" &&
  //     (!userData.is_board_complete || !userData.is_subscribed)
  //   ) {
  //     return navigate("/onboard");
  //   } else if (
  //     Component.auth.role !== "ALL" &&
  //     !Component.auth.role.includes(userData.type)
  //   ) {
  //     if (userData.type === "super-admin") {
  //       return <Navigate to="/myaccount" />;
  //     }
  //     return <Navigate to="/denied" />;
  //   }
  // }, [location]);

  if (!userData?.id) return <Navigate to="/login" replace />;
  else if (
    userData.type === "super-admin" &&
    (!userData.is_board_complete || !userData.is_subscribed)
  ) {
    return navigate("/onboard");
  } else if (
    Component.auth.role !== "ALL" &&
    // !new RegExp(userData.type, "gim").test(Component.auth.role)
    !Component.auth.role.includes(userData.type)
  ) {
    if (userData.type === "super-admin") {
      return <Navigate to="/myaccount" />;
    }
    return <Navigate to="/denied" />;
  }

  let styleVars = {};
  
  if(color_palettes){
    styleVars = Object.keys(color_palettes).reduce((acc, shade) => {
      acc[`--bg-color-${shade}`] = color_palettes[shade];
      return acc;
    }, {});
  }

  return (
    <div
      className="flex max-h-screen overflow-hidden"
      onDrop={(e) => {
        const clientRect = e.currentTarget.getBoundingClientRect();
        setPosition({
          right: clientRect.right + e.clientX - clientX,
          bottom: clientRect.bottom + e.clientY - clientY,
        });
      }}
      style={{
        ...styleVars
      }}
    >
      <Sidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        notificationList={notificationList}
        setNotificationList={setNotificationList}
        requestCount={requestCount}
        setRequestCount={setRequestCount}
      />
      <div className="w-full h-full overflow-y-scroll lg:overflow-y-auto bg-white scrollbar scrollbar-w-2 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100">
        <main className="h-screen w-full pb-[64px]">
          <Header
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            user={user}
            notificationList={notificationList}
            setNotificationList={setNotificationList}
          />
          <Component user={user} />
          {/* {children} */}
        </main>
      </div>
    </div>
  );
};

export default AuthLayout;
